import { AMPPageHeader } from "@advice/components/organisms/AMPPageHeader";
import { Location } from "@advice/hooks/Location";
import { User } from "@advice/hooks/User";
import { useWindowSize } from "@advice/hooks/windowSize";
import { Header, HeaderProps } from "@themuse/muse-front-end";
import { get } from "@util/object";
import React from "react";

const PageHeader: React.FC = () => {
    const user = React.useContext(User);
    const location = React.useContext(Location);
    // We cannot pull the hash value as it is never actually sent to the server.
    const encodedURL = encodeURIComponent(location.pathname + location.search);
    const [searchQuery, setSearchQuery] = React.useState("");
    const companyName = get(user.company, "short_name");
    const userCompanySettingsUrl = companyName ? `/clients/${companyName}` : null;
    const userName = user.cropped_name || "Guest";
    const { isAMP } = React.useContext(Location);

    if (isAMP) {
        return <AMPPageHeader />;
    }

    const headerProps: HeaderProps = {
        activePath: "/advice",
        searchEnabled: true,
        fixed: true,
        signInUrl: `/user/login?next=${encodedURL}`,
        searchQuery,
        userAuthed: user.logged_in,
        userCompanySettingsUrl,
        userName,
        viewBookings: true,
        mainContainerId: "main-content"
    };

    return <Header {...headerProps} />;
};

export { PageHeader };
